module.exports = "<p>\r\n  master-detail works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/detail/master-detail/master-detail.component.html
// module id = ./src/app/components/detail/master-detail/master-detail.component.html
// module chunks = main